export const strategicImperativeFragment = `
  _id
  title
  description
  therapeuticArea
  year
  updated
`;
